export function FooterTrustpilotSkeleton() {
  return (
    <div className="grid grid-cols-5 gap-9 px-10 pb-10 pt-12 md:pb-14 md:pt-16">
      <div className="flex animate-pulse flex-col gap-2">
        <div className="h-4 w-full bg-gray-100" />
        <div className="h-4 w-20 bg-gray-100" />
        <div className="h-8 bg-gray-50" />
        <div className="h-4 w-40 bg-gray-50" />
        <div className="h-4 w-20 bg-gray-50" />
      </div>
      <div className="flex animate-pulse flex-col gap-2">
        <div className="h-4 w-full bg-gray-100" />
        <div className="h-4 w-20 bg-gray-100" />
        <div className="h-8 bg-gray-50" />
        <div className="h-4 w-40 bg-gray-50" />
        <div className="h-4 w-20 bg-gray-50" />
      </div>
      <div className="flex animate-pulse flex-col gap-2">
        <div className="h-4 w-full bg-gray-100" />
        <div className="h-4 w-20 bg-gray-100" />
        <div className="h-8 bg-gray-50" />
        <div className="h-4 w-40 bg-gray-50" />
        <div className="h-4 w-20 bg-gray-50" />
      </div>
      <div className="flex animate-pulse flex-col gap-2">
        <div className="h-4 w-full bg-gray-100" />
        <div className="h-4 w-20 bg-gray-100" />
        <div className="h-8 bg-gray-50" />
        <div className="h-4 w-40 bg-gray-50" />
        <div className="h-4 w-20 bg-gray-50" />
      </div>
      <div className="flex animate-pulse flex-col gap-2">
        <div className="h-4 w-full bg-gray-100" />
        <div className="h-4 w-20 bg-gray-100" />
        <div className="h-8 bg-gray-50" />
        <div className="h-4 w-40 bg-gray-50" />
        <div className="h-4 w-20 bg-gray-50" />
      </div>
    </div>
  );
}
